import React, {useEffect, useState } from "react";
import "../../assets/css/finalreporttable.css";
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { setFinalAssetAnalysisJSON } from '../../redux/actions/assetActions';
import { get } from "react-hook-form";
import { getAuthToken, getFacilityId, getModifiedBy, getcompanyId } from "../../utility/tokenUtility";
import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph, ifacSecurityURL } from "../../utility/apiURLS";
export default function AssetFinalreport({
  finalReportDetails,
  AssetType,
}) {
  let getsubDetails = finalReportDetails ? finalReportDetails : [];
  const warrantyStartDate = getsubDetails?.warrantystartdate;
  const warrantyEndDate = getsubDetails?.warrantyenddate;
  const commissioningDate = getsubDetails?.commissioningdate;

  const dispatch = useDispatch();
  const arrOne = [
    ...(getsubDetails?.femassetpurchasecostflag?.femassetregisters?.[0]?.femunscheduledworkorderheaders || []).map(item => ({
      ...item,
      category: "UnSchduled"
    })),
    ...(getsubDetails?.femassetpurchasecostflag?.femassetregisters?.[0]?.femscheduledworkorderheaders || []).map(item => ({
      ...item,
      category: "Schduled"
    }))
  ];

  const arrTwo = [
    ...(getsubDetails?.bemassetpurchasecostflag?.bemassetregisters?.[0]?.bemunscheduledworkorderheaders || []).map(item => ({
      ...item,
      category: "UnSchduled"
    })),
    ...(getsubDetails?.bemassetpurchasecostflag?.bemassetregisters?.[0]?.bemscheduledworkorderheaders || []).map(item => ({
      ...item,
      category: "Schduled"
    }))
  ];

  

// Merge the arrays
  const mergedArray = [...arrOne, ...arrTwo];

  let finalWorkOrderJSON;
  try {
    if (AssetType === "FEMS") {
      if (finalReportDetails) {
        finalWorkOrderJSON = {
          assetDetails: {
            rentalStatus: getsubDetails?.rentalStatus || "",
            tcNo: getsubDetails?.testingandcommissionvalue || "",
             tcOldNo: getsubDetails?.testcommissionoldno || "",
            oldAssetNo: getsubDetails?.oldassetno || "",
            assetClassification: getsubDetails?.assetClassificationCode || "",
            financeAssetNo: getsubDetails?.finanaceassetno || "",
            assetDescription: getsubDetails?.assetDescription || "",
            typeDescription: getsubDetails?.typedescription || "",
            typeCode: getsubDetails?.assetTypeCode || "",
            locationNo: getsubDetails?.locationNo || "",
            locationName: getsubDetails?.locationdesc || "",
            userDepartment: getsubDetails?.userDescription || "",
            departmentDescription: getsubDetails?.departmentdesc || "",
            criticality: getsubDetails?.criticalityvalue || "",
            workGroup: getsubDetails?.workgroup || "",
            ppmRequired: getsubDetails?.isppmrequiredflag == true ? "YES" : "NO" || "",
            //  ppmStatus: getsubDetails?.femassetpurchasecostflag?.femassetregisters[0]?.femassetppmstatus?.ppmstatus || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.bemassetppmstatus?.ppmstatus || "",
             ppmStatus: getsubDetails?.femassetpurchasecostflag?.femassetregisters?.[0]?.femassetppmstatus?.ppmstatus || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters?.[0]?.bemassetppmstatus?.ppmstatus ||getsubDetails?.bemassetpurchasecostflag?.bemassetppmstatus?.ppmstatus || "",
             
             // ppmStatus:  getsubDetails?.femassetppmstatus?.ppmstatus || getsubDetails?.bemassetppmstatus?.ppmstatus || "",
            parentAssetNo:"",
            Description: "",
            reason: getsubDetails?.femassetpurchasecostflag?.femassetregisters[0]?.reason || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.reason || "",
          },
          
          assetSpecification: {
            make: getsubDetails?.make || "",
            brand: getsubDetails?.brand || "",
            model: getsubDetails?.model || "",
            serialNo: getsubDetails?.serialno || "",
            capacity: getsubDetails?.capacity || "",
            assetStatus: getsubDetails?.assetStatus || "",
            lifeSpan: getsubDetails?.lifespan || "",
            manufacture: getsubDetails?.manufacturer || "",
          },
          purchaseDetails: {
            purchaseOrderNo: getsubDetails?.purchaseorderno || "",
            purchaseCostInRM: getsubDetails?.purchasecost || "",
            // purchaseFlag: getsubDetails?.femassetpurchasecostflag?.purchasecostflag || getsubDetails?.bemassetpurchasecostflag?.purchasecostflag || "",
            purchaseFlag: getsubDetails?.femassetpurchasecostflag?.purchasecostflag 
              && getsubDetails?.femassetpurchasecostflag?.purchasecostflag.trim() !== "" 
              ? getsubDetails?.femassetpurchasecostflag?.purchasecostflag 
              : getsubDetails?.bemassetpurchasecostflag?.purchasecostflag 
                && getsubDetails?.bemassetpurchasecostflag?.purchasecostflag.trim() !== "" 
                ? getsubDetails?.bemassetpurchasecostflag?.purchasecostflag 
                : "",

           warrantyStartDate: warrantyStartDate ? moment(warrantyStartDate).format('DD/MM/YYYY') : '',
            warrantyEndDate: warrantyEndDate ? moment(warrantyEndDate).format('DD/MM/YYYY') : '',
            commissioningDate: commissioningDate ? moment(commissioningDate).format('DD/MM/YYYY') : '',
            accessories: getsubDetails?.accessories || "",
            underWaranty: getsubDetails?.isunderwarranty == true ? "YES" : "NO" || "",
            cumulativePartCostInRM: "",
            lastScheduledWorkOrder: getsubDetails?.lastscheduledworkorder || "",
            lastUnscheduledWorkOrder: getsubDetails?.lastunscheduledworkorder || "",
            depreciationValueYearInRm: getsubDetails?.femassetpurchasecostflag?.femassetregisters[0]?.depreciationvalue || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.depreciationvalue || "",
            assetTransferCategory: getsubDetails?.femassetpurchasecostflag?.femassetregisters[0]?.femassettransfer?.assettransfer || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.bemassettransfer?.assettransfer || "",
          },
          maintenanceHistory: {
            woNo: "",
            woDate: "",
            woType: "",
          }
        };
      }
 
    } else {
      finalWorkOrderJSON = {
        assetDetails: {
          rentalStatus: getsubDetails?.rentalStatus || "",
          tcNo: getsubDetails?.testingandcommissionvalue || "",
           tcOldNo: getsubDetails?.testcommissionoldno || "",
          oldAssetNo: getsubDetails?.oldassetno || "",
          assetClassification: getsubDetails?.assetClassificationCode || "",
          financeAssetNo: getsubDetails?.finanaceassetno || "",
          assetDescription: getsubDetails?.assetDescription || "",
          typeDescription: getsubDetails?.typedescription || "",
          typeCode: getsubDetails?.assetTypeCode || "",
          locationNo: getsubDetails?.locationNo || "",
          locationName: getsubDetails?.locationdesc || "",
          userDepartment: getsubDetails?.userDescription || "",
          departmentDescription: getsubDetails?.departmentdesc || "",
          criticality: getsubDetails?.criticalityvalue || "",
          workGroup: getsubDetails?.workgroup || "",
          ppmRequired: getsubDetails?.isppmrequiredflag == true ? "YES" : "NO" || "",
          ppmStatus: getsubDetails?.femassetpurchasecostflag?.femassetregisters?.[0]?.femassetppmstatus?.ppmstatus || getsubDetails?.bemassetpurchasecostflag?.bemassetregisters?.[0]?.bemassetppmstatus?.ppmstatus ||getsubDetails?.bemassetpurchasecostflag?.bemassetppmstatus?.ppmstatus || "",

          // ppmStatus :getsubDetails?.femassetpurchasecostflag?.femassetppmstatus?.ppmstatus || getsubDetails?.bemassetpurchasecostflag?.bemassetppmstatus?.ppmstatus || "",
          // getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.bemassetppmstatus?.ppmstatus || "",
          // parentAssetNo:getsubDetails?.parentassetid||"",
          parentAssetNo:"",
          Description: "",
          reason: getsubDetails?.reason || "",
        },
        assetSpecification: {
          make: getsubDetails?.make || "",
          brand: getsubDetails?.brand || "",
          model: getsubDetails?.model || "",
          serialNo: getsubDetails?.serialno || "",
          capacity: getsubDetails?.capacity || "",
          assetStatus: getsubDetails?.assetStatus || "",
          lifeSpan: getsubDetails?.lifespan || "",
          manufacture: getsubDetails?.manufacturer || "",
        },
        purchaseDetails: {
          purchaseOrderNo: getsubDetails?.purchaseorderno || "",
          purchaseCostInRM: getsubDetails?.purchasecost || "",
          purchaseFlag: getsubDetails?.femassetpurchasecostflag?.purchasecostflag 
          && getsubDetails?.femassetpurchasecostflag?.purchasecostflag.trim() !== "" 
          ? getsubDetails?.femassetpurchasecostflag?.purchasecostflag 
          : getsubDetails?.bemassetpurchasecostflag?.purchasecostflag 
            && getsubDetails?.bemassetpurchasecostflag?.purchasecostflag.trim() !== "" 
            ? getsubDetails?.bemassetpurchasecostflag?.purchasecostflag 
            : "",

          warrantyStartDate: warrantyStartDate ? moment(warrantyStartDate).format('DD/MM/YYYY') : '',
          warrantyEndDate: warrantyEndDate ? moment(warrantyEndDate).format('DD/MM/YYYY') : '',
          commissioningDate: commissioningDate ? moment(commissioningDate).format('DD/MM/YYYY') : '',
          accessories: getsubDetails?.accessories || "",
          underWaranty: getsubDetails?.isunderwarranty == true ? "YES" : "NO" || "",
          cumulativePartCostInRM: "",
          lastScheduledWorkOrder: getsubDetails?.lastscheduledworkorder || "",
          lastUnscheduledWorkOrder: getsubDetails?.lastunscheduledworkorder || "",
          depreciationValueYearInRm: getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.depreciationvalue || "",
          assetTransferCategory: getsubDetails?.bemassetpurchasecostflag?.bemassetregisters[0]?.bemassettransfer?.assettransfer|| "",
       
        },
        maintenanceHistory: {
          woNo: "",
          woDate: "",
          woType: "",
        }
      };
    }
  } catch (error) {
    console.error("Error building finalWorkOrderJSON:", error);
  }

// Extract maintenance history data
const maintenanceHistoryData = getsubDetails?.scheduledWorkOrder?.map(order => [
  ["WO No", order.workOrderNo],
  ["WO Date", moment(order.workOrderDate).format("DD/MM/YYYY")], // Formatting the date
  ["WO Type", order.workOrderType]
]) || [];
// Flatten the maintenance history data
const flattenedMaintenanceHistoryData = maintenanceHistoryData.flat();

  const formattedData = [
    // Data from getsubDetails.scheduledWorkOrder
    ...getsubDetails?.scheduledWorkOrder?.map((workHistory) => ({
      workOrderNo: workHistory.workOrderNo,  // workOrderNo
      workOrderDate: moment(workHistory.workOrderDate).format('DD/MM/YYYY'),  // Formatted workOrderDate
      workOrderType: workHistory.workOrderType  // workOrderType
    }))
  ];


  
  const sections = [
    {
      title: 'Asset Details', data: [
        ["Asset No", getsubDetails?.assetNo],
        ["Rental Status", finalWorkOrderJSON?.assetDetails.rentalStatus, "T&C No.", finalWorkOrderJSON?.assetDetails.tcNo],
        ["T&C Old No.", finalWorkOrderJSON?.assetDetails.tcOldNo, "Old Asset No", finalWorkOrderJSON?.assetDetails.oldAssetNo],
        ["Asset Classification", finalWorkOrderJSON?.assetDetails.assetClassification, "Finance Asset No.", finalWorkOrderJSON?.assetDetails.financeAssetNo],
        ["Asset Description", finalWorkOrderJSON?.assetDetails.assetDescription, "Type Description", finalWorkOrderJSON?.assetDetails.typeDescription],
        ["Type Code", finalWorkOrderJSON?.assetDetails.typeCode, "Location No", finalWorkOrderJSON?.assetDetails.locationNo],
        ["Location Name", finalWorkOrderJSON?.assetDetails.locationName, "User Department", finalWorkOrderJSON?.assetDetails.userDepartment],
        ["Department Description", finalWorkOrderJSON?.assetDetails.departmentDescription, "Criticality", finalWorkOrderJSON?.assetDetails.criticality],
        ["Work Group", finalWorkOrderJSON?.assetDetails.workGroup, "PPM Required", finalWorkOrderJSON?.assetDetails.ppmRequired],
        ["PPM Status", finalWorkOrderJSON?.assetDetails.ppmStatus, "Parent Asset No", finalWorkOrderJSON?.assetDetails.parentAssetNo],
        ["Description", finalWorkOrderJSON?.assetDetails.Description, "Reason", finalWorkOrderJSON?.assetDetails.reason],
      ]
    },
    {
      title: 'Asset Specification', data: [
        ["Make", finalWorkOrderJSON?.assetSpecification.make, "Brand", finalWorkOrderJSON?.assetSpecification.brand],
        ["Model", finalWorkOrderJSON?.assetSpecification.model, "Serial No", finalWorkOrderJSON?.assetSpecification.serialNo],
        ["Capacity", finalWorkOrderJSON?.assetSpecification.capacity, "Asset status", finalWorkOrderJSON?.assetSpecification.assetStatus],
        ["Life Span(yrs)", finalWorkOrderJSON?.assetSpecification.lifeSpan, "Manufacture", finalWorkOrderJSON?.assetSpecification.manufacture],
      ]
    },
    {
      title: 'Purchase Details', data: [
        ["Purchase Order No", finalWorkOrderJSON?.purchaseDetails.purchaseOrderNo, "Purchase Cost in RM", finalWorkOrderJSON?.purchaseDetails.purchaseCostInRM],
        ["Purchase Flag", finalWorkOrderJSON?.purchaseDetails.purchaseFlag, "Warranty Start Date", finalWorkOrderJSON?.purchaseDetails.warrantyStartDate],
        ["Warranty End Date", finalWorkOrderJSON?.purchaseDetails.warrantyEndDate, "Commissioning Date", finalWorkOrderJSON?.purchaseDetails.commissioningDate],
        ["Accessories", finalWorkOrderJSON?.purchaseDetails.accessories, "Under waranty", finalWorkOrderJSON?.purchaseDetails.underWaranty],
        ["Cumulative Part Cost in (RM)", finalWorkOrderJSON?.purchaseDetails.cumulativePartCostInRM, "Last Scheduled Work Order", finalWorkOrderJSON?.purchaseDetails.lastScheduledWorkOrder],
        ["Last Unscheduled Work Order", finalWorkOrderJSON?.purchaseDetails.lastUnscheduledWorkOrder, "Depreciation value/Year in RM", finalWorkOrderJSON?.purchaseDetails.depreciationValueYearInRm],
        ["Asset Transfer Category", finalWorkOrderJSON?.purchaseDetails.assetTransferCategory, "", ""],
      ]
    },
    // {
    //   title: 'Maintenance History', data: [
    //     ["WO No", finalWorkOrderJSON?.maintenanceHistory.woNo],
    //     ["Wo Date", finalWorkOrderJSON?.maintenanceHistory.woDate],
    //     ["Wo Type", finalWorkOrderJSON?.maintenanceHistory.woType]
    //   ]
    // },

   {
    title: 'Maintenance History',
    data: [
      ["workOrderNo", "workOrderDate", "workOrderType"],  // Column headers
      ...formattedData.map(item => [item.workOrderNo, item.workOrderDate, item.workOrderType])  // Data rows
    ]
  }
    // Now, you can process this section as needed (e.g., add to worksheet)
    

  ];
  dispatch(setFinalAssetAnalysisJSON(sections));

  const parentAssetNo = getsubDetails?.parentassetid;
  const setParentAssetNoOptions = async () => {
    const config = {
        headers: {
            Authorization: `Bearer ${getAuthToken("id_token")}`, 
        },
    };

    const facilityId = getFacilityId("facilityId");


    if (parentAssetNo) { 
        try {
            // setIsLoading(true);
            let response;
            
            if (AssetType === "FEMS") {
                response = await axios.get(
                    `${FemsGraph}/api/GraphAssetRegister/GetParentAssetNobyFacilityId/${facilityId}/${parentAssetNo}?size=10000`,
                    config
                );
            } else {
                response = await axios.get(
                    `${BemsGraph}/api/GraphAssetRegister/GetParentAssetNobyFacilityId/${facilityId}/${parentAssetNo}?size=10000`,
                    config
                );
            }

            const parentAssetOptions = response?.data?.map((item, index) => ({
                key: `option-${index}`,
                id: item?.id,
                label: `${item?.assetno} - ${item?.assetdesc}`,
                code: item?.assetno,
                assetdesc: item?.assetdesc
            }));

            // Use parentAssetOptions as needed, e.g., updating state
            console.log("Parent Asset Options:", parentAssetOptions);

        } catch (error) {
            console.error("Failed to fetch asset data:", error);
        }
    }
};


useEffect(()=>{
    setParentAssetNoOptions ();
})
 

  return (
    <>
      <div className="finalreport-table-container">
        <div id="printableArea">

          <div className="unscheduled-work">
            <table>
              <thead>
                <tr>
                  <th colSpan={8} className="unscheduled-center-text" style={{
                    backgroundColor: '#009999',
                    color: 'white',
                    textAlign: 'center',
                  }}>
                    ASSET DETAILS
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="label">Asset No.</td>
                  <td colSpan={3}>{getsubDetails?.assetNo}</td>
                </tr>

                <tr>
                  <td className="label">Rental Status</td>
                  <td>{finalWorkOrderJSON?.assetDetails.rentalStatus}</td>

                  <td className="label">T&C No.</td>
                  <td>{finalWorkOrderJSON?.assetDetails.tcNo}</td>
                </tr>

                <tr>
                  <td className="label">T&C Old No.</td>
                  <td>{finalWorkOrderJSON?.assetDetails.tcOldNo}</td>

                  <td className="label">Old Asset No</td>
                  <td>{finalWorkOrderJSON?.assetDetails.oldAssetNo}</td>
                </tr>

                <tr>
                  <td className="label">Asset Classification</td>
                  <td>{finalWorkOrderJSON?.assetDetails.assetClassification}</td>

                  <td className="label">Finance Asset No.</td>
                  <td>{finalWorkOrderJSON?.assetDetails.financeAssetNo}</td>


                </tr>

                <tr>
                  <td className="label">Asset Description</td>
                  <td>{finalWorkOrderJSON?.assetDetails.assetDescription}</td>

                  <td className="label">Type Description</td>
                  <td>{finalWorkOrderJSON?.assetDetails.typeDescription}</td>
                </tr>

                <tr>
                  <td className="label">Type Code</td>
                  <td>{finalWorkOrderJSON?.assetDetails.typeCode}</td>

                  <td className="label">Location No</td>
                  <td>{finalWorkOrderJSON?.assetDetails.locationNo}</td>


                </tr>

                <tr>
                  <td className="label">Location Name</td>
                  <td>{finalWorkOrderJSON?.assetDetails.locationName}</td>

                  <td className="label">User Department</td>
                  <td>{finalWorkOrderJSON?.assetDetails.userDepartment}</td>
                </tr>



                <tr>
                  <td className="label">Department Description</td>
                  <td>{finalWorkOrderJSON?.assetDetails.departmentDescription}</td>

                  <td className="label">Criticality</td>
                  <td>{finalWorkOrderJSON?.assetDetails.criticality}</td>
                </tr>

                <tr>
                  <td className="label">Work Group</td>
                  <td>{finalWorkOrderJSON?.assetDetails.workGroup}</td>

                  <td className="label">PPM Required</td>
                  <td>{finalWorkOrderJSON?.assetDetails.ppmRequired}</td>
                </tr>

                <tr>
                  <td className="label">PPM Status </td>
                  <td>{finalWorkOrderJSON?.assetDetails.ppmStatus}</td>

                  <td className="label">Parent Asset No</td>
                  <td>{finalWorkOrderJSON?.assetDetails.parentAssetNo}</td>
                </tr>

                <tr>
                  <td className="label">Description</td>
                  <td>{finalWorkOrderJSON?.assetDetails.Description}</td>

                  <td className="label">Reason</td>
                  <td>{finalWorkOrderJSON?.assetDetails.reason}</td>
                </tr>


              </tbody>


            </table>
          </div>
          {/* table 2 */}
          <div className="unscheduled-work">
            <table>
              <thead>
                <tr>
                  <th colSpan={10} className="unscheduled-center-text" style={{
                    backgroundColor: '#009999',
                    color: 'white',
                    textAlign: 'center',
                  }}>
                    Asset Specification
                  </th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td className="label">Make</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.make}</td>

                  <td className="label">Brand</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.brand}</td>
                </tr>

                <tr>
                  <td className="label">Model</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.model}</td>

                  <td className="label">Serial No</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.serialNo}</td>
                </tr>

                <tr>
                  <td className="label">Capacity</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.capacity}</td>

                  <td className="label">Asset status</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.assetStatus}</td>
                </tr>

                <tr>
                  <td className="label">Life Span(yrs)</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.lifeSpan}</td>

                  <td className="label">Manufacture</td>
                  <td>{finalWorkOrderJSON?.assetSpecification.manufacture}</td>

                </tr>

              </tbody>
            </table>
          </div>

          {/* 3 table */}

          <div className="unscheduled-work">
            <table>
              <thead>
                <tr>
                  <th colSpan={10} className="unscheduled-center-text" style={{
                    backgroundColor: '#009999',
                    color: 'white',
                    textAlign: 'center',
                  }}>
                    Purchase Details
                  </th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td className="label">Purchase Order No</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.purchaseOrderNo}</td>

                  <td className="label">Purchase Cost in RM</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.purchaseCostInRM}</td>
                </tr>

                <tr>
                  <td className="label">Purchase Flag</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.purchaseFlag}</td>

                  <td className="label">Warranty Start Date</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.warrantyStartDate}</td>
                </tr>

                <tr>
                  <td className="label">Warranty End Date</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.warrantyEndDate}</td>

                  <td className="label">Commissioning Date</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.commissioningDate}</td>
                </tr>

                <tr>
                  <td className="label">Accessories</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.accessories}</td>

                  <td className="label">Under waranty</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.underWaranty}</td>
                </tr>

                <tr>
                  <td className="label">Cumulative Part Cost in (RM)</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.cumulativePartCostInRM}</td>

                  <td className="label">Last Scheduled Work Order</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.lastScheduledWorkOrder}</td>
                </tr>

                <tr>
                  <td className="label">Last Unscheduled Work Order</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.lastUnscheduledWorkOrder}</td>

                  <td className="label">Depreciation value/Year in RM</td>
                  <td>{finalWorkOrderJSON?.purchaseDetails.depreciationValueYearInRm}</td>
                </tr>

                <tr>
                  <td className="label">Asset Transfer Category</td>
                  <td colSpan={7}>{finalWorkOrderJSON?.purchaseDetails.assetTransferCategory}</td>


                </tr>

              </tbody>
            </table>
          </div>

          {/* 4 table */}

          <div className="unscheduled-work">
            <table>
              <thead>
                <tr>
                  <th colSpan={10} className="unscheduled-center-text" style={{
                    backgroundColor: '#009999',
                    color: 'white',
                    textAlign: 'center',
                  }}>
                    Maintenance History
                  </th>
                </tr>
              </thead>


              <tr>
                <th>WO No</th>
                <th>Wo Date</th>
                <th>Wo Type</th>
              </tr>
              <tbody>
                {/* <tr>                  
                  <td>
                  {finalWorkOrderJSON?.maintenanceHistory.woNo}
                  </td>
                  <td>
                  {finalWorkOrderJSON?.maintenanceHistory.woDate}
                  </td>
                  <td>
                  {finalWorkOrderJSON?.maintenanceHistory.woType}
                  </td>
               </tr> */}
                {/* {getsubDetails?.femassetpurchasecostflag?.femassetregisters[0]?.femunscheduledworkorderheaders?.map((history, index) => ( */}
                {getsubDetails?.scheduledWorkOrder?.map((history, index) => (

                  <tr key={index}>
                    <td>{history.workOrderNo}</td>
                    <td>{history?.workOrderDate ? moment(history?.workOrderDate).format('DD/MM/YYYY') : ''}</td>
                    <td>{history.workOrderType}</td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>



        </div>
      </div>
    </>
  );
}
